import React from 'react';
import { Layout } from 'antd';
import {} from '@ant-design/icons';
import { Cards } from '../../components/ViewClients/Cards';
import AppLayout from '../../components/Layout/AppLayout';
import './ViewClient.css'

const {} = Layout;

const ViewClient = () => {

  return (

    <AppLayout
      title="View Clients"
    >
      <Layout
        style={{
          margin: '15px 30px 30px 30px',
        }}
      >
        <Cards />
      </Layout>
    </AppLayout>


  );
}

export default ViewClient;
